import React from 'react'
import { Text } from '../../atoms'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import ControlHighlight from '../../molecules/KeyboardControls/ControlHighlight'
import KeyboardControl from '../../molecules/KeyboardControls/KeyboardControl'

interface OptionProps {
  text: string
  onClick?: () => void
  focusableElement: string
}

const Option: React.FC<OptionProps> = ({ text, focusableElement = '', onClick }) => {
  const keyboardControls = useKeyboardControls()
  return (
    <ControlHighlight
      active={keyboardControls.isEnabled && keyboardControls.isElementFocused(focusableElement)}
      highlightEffect={HighlightEffect.LinkUnderline}
      data-testid={`highlight-${focusableElement}`}
    >
      <KeyboardControl>
        <button
          id={focusableElement}
          className='option underline text-[26px] text-dopage-lightGreen cursor-pointer'
          onClick={onClick}
        >
          <Text text={text} className='font-white' />
        </button>
      </KeyboardControl>
    </ControlHighlight>
  )
}

export default Option
